import { Route, RouteConfig } from 'vue-router'

export const Home: RouteConfig = {
  path: '/school-class-super-league/home',
  name: 'school_class_super_league_home',
  component: () => import('../activity/school-class-super-league/Home.vue'),
  props: (_route: Route) => ({ id: _route.query.id }),
  meta: {
    title: '课间屏AI赛事',
  },
}

export const Records: RouteConfig = {
  path: '/school-class-super-league/records',
  name: 'school_class_super_league_records',
  component: () => import('../activity/school-class-super-league/Records.vue'),
  props: (_route: Route) => ({ id: _route.query.id }),
  meta: {
    title: '我的成绩',
  },
}

export const Rank: RouteConfig = {
  path: '/school-class-super-league/rank',
  name: 'school_class_super_league_rank',
  component: () => import('../activity/school-class-super-league/Rank.vue'),
  props: (_route: Route) => ({ id: _route.query.id }),
  meta: {
    title: '比赛排行榜',
  },
}

export default [Home, Records, Rank]
